import styles from "./AssessmentFor.module.scss";
import { Card } from "@/pages/MainPage/ui/MyProducts/ui/AssessmentFor/Card";
import photo1 from "../../../assets/assessmentForCard1.jpg";
import photo2 from "../../../assets/assessmentForCard2.jpg";

const cards = [
    {
        text: "You can’t control yourself and you work a lot.",
        position: "01",
    },
    {
        text: "Your daily routine is disrupted, you lack concentration, you’re in bad mood, feel tension in your head.",
        position: "02",
    },
    {
        text: "You have the feeling that there is no possibility to live normally, you are on edge, sleep does not give rest, there is no strength to work.",
        position: "03",
    },
    {
        photo: photo1,
    },
    {
        text: "You feel hopelessness, disappointment in yourself and your loved ones, in your work, inability to talk to anyone.",
        position: "04",
    },
    {
        photo: photo2,
    },
    {
        text: "You feel apathy, depression, low mood, you get irritated with people.",
        position: "05",
    },
    {
        text: "You can’t make yourself do anything; you don’t tolerate the climate, the team, the environment well, etc.",
        position: "06",
    },
];

export const AssessmentFor = () => {
    return (
        <div className={styles.AssessmentFor}>
            <div className={styles.title}>
                You <span>should come</span> for a consultation if you:
            </div>
            <div className={styles.content}>
                {cards.map((card, index) => {
                    if (card.photo) {
                        return <Card photo={card.photo} key={index} />;
                    } else {
                        return (
                            <Card
                                text={card.text}
                                position={card.position}
                                key={index}
                            />
                        );
                    }
                })}
            </div>
        </div>
    );
};
